import React from 'react'
import Chip from '@mui/material/Chip'
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  kycStatus: string | undefined
}

export const KYCStatusChip: React.FC<ComponentProps> = ({ kycStatus }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (kycStatus === 'NEW') {
    color = 'primary'
    variant = 'outlined'
  } else if (kycStatus === 'PENDING') {
    color = 'warning'
    variant = 'outlined'
  } else if (kycStatus === 'PASSED') {
    color = 'success'
    variant = 'outlined'
  } else if (kycStatus === 'FAILED') {
    color = 'error'
    variant = 'outlined'
  } else if (kycStatus === 'SUPERSEDED') {
    variant = 'outlined'
  } else if (kycStatus === 'MANUAL_REVIEW') {
    color = 'secondary'
    variant = 'outlined'
  } else {
    variant = 'outlined'
  }

  return (
      <Tooltip title={kycStatus} TransitionComponent={Zoom} arrow placement='bottom'>
      <Chip icon={<MilitaryTechIcon />} label={kycStatus} variant={variant} color={color} />
      </Tooltip>

  )
}
